<template>
  <Listbox v-model="selected" :disabled="disabled">
    <div class="relative w-full drop-down">
      <ListboxButton
        class="w-full py-2 px-2 md:px-4 border border-brand-mid-gray shadow-sm rounded focus:border-brand-green focus:ring-brand-green max-w-50 bg-white"
        :class="{
          'bg-brand-light-gray': (showSelectedAsGray && !!(selected || initial)) || disabled
        }"
      >
        <div class="flex justify-between">
          <div class="flex text-left max-w-4/5">
            <span
              class="text-left text-sm md:text-base truncate overflow-ellipsis"
              :class="{
                'text-brand-mid-gray': showSelectedAsGray && !(selected || initial)
              }"
              >{{ selected ? selected.label : initial ? initial.label : placeholder }}</span
            >
          </div>
          <div class="flex flex-row-reverse">
            <img src="@/assets/icons/chevron-down.svg" class="w-4 md:w-5" />
          </div>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-40 md:max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
          :class="[dropDownSize]"
        >
          <slot name="option">
            <ListboxOption
              v-slot="{ active }"
              v-for="(item, idx) in options"
              :key="item.label"
              :value="item"
              as="template"
            >
              <li
                class="max-w-full w-full px-2 cursor-pointer"
                :class="[
                  active ? 'text-white bg-brand-green' : 'text-brand-black',
                  'cursor-default select-none relative py-2 hover:bg-brand-green group'
                ]"
              >
                <span
                  class="flex mx-auto text-sm md:text-base"
                  :class="[active ? 'text-white' : 'group-hover:text-white']"
                  :ref="`list-option-${idx}`"
                  >{{ item.label }}</span
                >
              </li>
            </ListboxOption>
          </slot>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>
<script>
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue"

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    initial: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: "Select"
    },
    showSelectedAsGray: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropDownSize: {
      type: String,
      default: "h-40"
    }
  },
  mounted() {},
  data() {
    return {
      selected: null
    }
  },
  watch: {
    selected(val, oldVal) {
      if (!oldVal && this.initial && val.value === this.initial.value) {
        return
      }
      this.$emit("select", val)
    }
  },
  methods: {}
}
</script>
<style scoped>
/* @keyframes moveText {
  100% {
    transform: translateX(-50%);
  }
}

.slide-text {
  animation: moveText 10s linear infinite;
} */
</style>
